export enum ClearanceOutput {
    Cleared = 'Cleared',
    NotAppointed = 'NotAppointed',
    Duplicate = 'Duplicate',
}
